import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  rsuList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    alignItems: 'center',
    '& li': {
      margin: 0,
      padding: 0,
      lineHeight: 1,
    },
  },
  rsuLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    margin: 0,
    fontSize: '0.7rem',
    lineHeight: 1.2,
    padding: '1px 6px',
    borderRadius: 3,
    background: 'rgba(0, 90, 187, 0.05)',
    color: '#005abb',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    verticalAlign: 'top',
    maxWidth: '100%',
    '&:hover': {
      background: 'rgba(0, 90, 187, 0.18)',
      color: '#003f82',
    },
  },
  rsuStatusIcon: {
    display: 'inline-flex',
    flexShrink: 0,
    lineHeight: 0,
    '& svg': {
      width: 14,
      height: 14,
    },
  },
  rsuLinkLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  rsuText: {
    display: 'inline-block',
    margin: 0,
    fontSize: '0.7rem',
    lineHeight: 1.2,
    padding: '1px 6px',
    color: 'inherit',
    verticalAlign: 'top',
  },
}));

export default styles;
